<script setup>
import { onMounted, ref } from 'vue'
import router from '@/router'

const breadcrumbs = ref()

const resolveMatchedPath = (path, params = {}) => {
  return path.replace(/:([A-Za-z0-9_]+)/g, (_, key) => {
    const value = params[key]
    return value === undefined || value === null ? `:${key}` : encodeURIComponent(String(value))
  })
}

const getBreadcrumbs = () => {
  const currentRoute = router.currentRoute.value

  return currentRoute.matched.map((route, index) => {
    const resolvedPath = resolveMatchedPath(route.path, currentRoute.params)

    return {
      active: index === currentRoute.matched.length - 1,
      name: route.name,
      path: `${router.options.history.base}${resolvedPath}`,
    }
  })
}

router.afterEach(() => {
  breadcrumbs.value = getBreadcrumbs()
})

onMounted(() => {
  breadcrumbs.value = getBreadcrumbs()
})
</script>

<template>
  <CBreadcrumb class="my-0">
    <CBreadcrumbItem
      v-for="item in breadcrumbs"
      :key="item"
      :href="item.active ? '' : item.path"
      :active="item.active"
    >
      {{ item.name }}
    </CBreadcrumbItem>
  </CBreadcrumb>
</template>
